export const typeMapApiName = {
    1: 'rateOneMonth',
    2: 'rateThreeMonth',
    3: 'rateHalfYear',
    4: 'rateOneYear',
    5: 'rateThreeYear',
    6: 'rateSinceExist',
    7: 'rateYearMonth',
    8: 'rateYear7days'
};

export const INCREASEENUM = {
    '1': {
        lg_idx_0: '近一月涨幅',
        lg_idx_1: '近一月漲幅',
        lg_idx_2: '% Change in 1 Mth',
        url: '/api/fund-increase/rate-1-month'
    },
    '2': {
        lg_idx_0: '近三月涨幅',
        lg_idx_1: '近三月漲幅',
        lg_idx_2: '% Change in 3 Mth',
        url: '/api/fund-increase/rate-3-month'
    },
    '3': {
        lg_idx_0: '近半年涨幅',
        lg_idx_1: '近半年漲幅',
        lg_idx_2: '% Change in 6 Mth',
        url: '/api/fund-increase/rate-6-month'
    },
    '4': {
        lg_idx_0: '近一年涨幅',
        lg_idx_1: '近一年漲幅',
        lg_idx_2: '% Change in 1 Yr',
        url: '/api/fund-increase/rate-1-year'
    },
    '5': {
        lg_idx_0: '近三年涨幅',
        lg_idx_1: '近三年漲幅',
        lg_idx_2: '% Change in 3 Yr',
        url: '/api/fund-increase/rate-3-year'
    },
    '6': {
        lg_idx_0: '成立以来涨幅',
        lg_idx_1: '成立以來漲幅',
        lg_idx_2: '% Change Since Inception',
        url: '/api/fund-increase/rate-all'
    },
    '7': {
        lg_idx_0: '近一月年化',
        lg_idx_1: '近一月年化',
        lg_idx_2: 'Last 1-Mth Yield',
        url: '/api/fund-increase/year-rate-month'
    },
    '8': {
        lg_idx_0: '近七日年化',
        lg_idx_1: '近七日年化',
        lg_idx_2: 'Last 7-Day Yield',
        url: '/api/fund-increase/year-rate-7-day'
    }
};

export const THEME = {
    '1': {
        normal: {
            'backgroundColor': '#f43819',
        },
        gradient: {
            'backgroundImage': 'linear-gradient(to right, #ff3a1a , #e92100)'
        }
    },
    '2': {
        normal: {
            'backgroundColor': '#ff8610',
        },
        gradient: {
            'backgroundImage': 'linear-gradient(to right, #ff9019 , #ff7510)'
        }
    },
    '3': {
        normal: {
            'backgroundColor': '#0e7bea',
        },
        gradient: {
            'backgroundImage': 'linear-gradient(to right, #2395ff , #0e7bea)'
        }
    },
    '4': {
        normal: {
            'backgroundColor': '#ab50ff',
        },
        gradient: {
            'backgroundImage': 'linear-gradient(to right, #be57ff , #a848ff)'
        }
    },
    '5': {
        normal: {
            'backgroundColor': '#f0d2b3',
            'color': '#4c301f'
        },
        gradient: {
            'backgroundImage': 'linear-gradient(to right, #f4d2af , #f2c494)',
            'color': '#4c301f'
        }
    },
    '6': {
        normal: {
            'backgroundColor': '#7e665a',
        },
        gradient: {
            'backgroundImage': 'linear-gradient(to right, #7e665a , #5d4b3a)'
        }
    },
    '7': {
        normal: {
            'backgroundColor': '#000000',
        },
        gradient: {
            'backgroundImage': 'linear-gradient(to right, #2e2a25 , #000000)'
        }
    }
};

export const getIncreaseOption = () => {
    return Object.keys(INCREASEENUM).map((key) => {
        const { lg_idx_0 } = INCREASEENUM[key];
        return { label: lg_idx_0, value: +key };
    });
};

/** 展示涨幅文案 */
export const getIncreaseTag = (type, index) => {
    return INCREASEENUM[type]?.[`lg_idx_${index}`] || INCREASEENUM[type]['lg_idx_2'];
};
